import SimplNodesControls from "./simplNodesControls";

class SimplBoxControls extends SimplNodesControls {
  async componentDidMount() {
    await super.componentDidMount();

    this.setState({
      selectedFunction: "addFunction",
      loadType: "SimplBox",
      manualSN: true,
      isCorrectSN: true,
      isCorrectRelay: true,
      isSNTaken: false,
      allowThermostatOverwrite: false,
    });
  }

  handleLoads = (e) => {
    const loadType = e.currentTarget.value;

    if (loadType === "SimplBox") {
      this.setState({
        loadType: "SimplBox",
        manualSN: true,
        isCorrectSN: true,
        isCorrectRelay: true,
      });
      return;
    }

    const {
      systemHandleID,
      companyName,
      userRole,
      displayWidth,
    } = this.props.match.params;
    const companyNameParam = encodeURIComponent(
      companyName || this.state.companyName || ""
    );
    const userRoleParam = userRole || "companyAdmin";
    const displayWidthParam = displayWidth || "Wide";

    this.props.history.push(
      `/systems/simplNodesControls/${systemHandleID}/${companyNameParam}/${userRoleParam}/${displayWidthParam}`
    );
  };
}

export default SimplBoxControls;
